const reviews = [
  {
    name: "James Mitchell",
    role: "Regular Shopper",
    text: "The GTBuy Spreadsheet system completely changed how I approach online shopping. I used to waste hours comparing prices manually across different platforms. Now everything is structured and I save at least 20% on every purchase. The comparison with Kakobuy and Superbuy features helped me pick the right approach.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20man%20on%20a%20clean%20cream%20studio%20background%2C%20soft%20natural%20daylight%2C%20warm%20neutral%20tones%2C%20friendly%20expression%2C%20editorial%20corporate%20portrait%20style%2C%20minimalist%20composition&width=120&height=120&seq=testimonial-avatar-1&orientation=squarish",
  },
  {
    name: "Emma Richardson",
    role: "Fashion Buyer",
    text: "As someone who shops across multiple platforms weekly, the GTBuy Spreadsheet has been a game-changer. The structured data approach means I never miss a better deal. Comparing GTBuy, Kakobuy, and Superbuy systems side by side gave me clarity I did not have before.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20woman%20on%20a%20clean%20cream%20studio%20background%2C%20soft%20natural%20daylight%2C%20warm%20neutral%20tones%2C%20friendly%20expression%2C%20editorial%20corporate%20portrait%20style%2C%20minimalist%20composition&width=120&height=120&seq=testimonial-avatar-2&orientation=squarish",
  },
  {
    name: "David Chen",
    role: "Bulk Purchaser",
    text: "I manage purchases for a small retail business and the spreadsheet-based intelligence system saves me hours every week. The comparison framework between different platforms helps me make data-backed decisions instead of guessing. Highly recommend the structured approach.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20an%20asian%20man%20on%20a%20clean%20cream%20studio%20background%2C%20soft%20natural%20daylight%2C%20warm%20neutral%20tones%2C%20friendly%20expression%2C%20editorial%20corporate%20portrait%20style%2C%20minimalist%20composition&width=120&height=120&seq=testimonial-avatar-3&orientation=squarish",
  },
  {
    name: "Sophia Laurent",
    role: "Lifestyle Blogger",
    text: "I review products across many categories and the GTBuy Spreadsheet methodology has become essential to my workflow. Tracking price history across GTBuy, Kakobuy, and Superbuy platforms lets me provide accurate, data-backed recommendations to my audience.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20woman%20with%20blonde%20hair%20on%20a%20clean%20cream%20studio%20background%2C%20soft%20natural%20daylight%2C%20warm%20neutral%20tones%2C%20friendly%20expression%2C%20editorial%20corporate%20portrait%20style%2C%20minimalist%20composition&width=120&height=120&seq=testimonial-avatar-4&orientation=squarish",
  },
  {
    name: "Marcus Williams",
    role: "Tech Enthusiast",
    text: "Finally a structured way to compare products across platforms. The spreadsheet approach seemed intimidating at first but the GTBuy system made it incredibly intuitive. My purchase accuracy has improved dramatically since I started using this comparison method.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20man%20with%20short%20hair%20on%20a%20clean%20cream%20studio%20background%2C%20soft%20natural%20daylight%2C%20warm%20neutral%20tones%2C%20friendly%20expression%2C%20editorial%20corporate%20portrait%20style%2C%20minimalist%20composition&width=120&height=120&seq=testimonial-avatar-5&orientation=squarish",
  },
];

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="w-10 h-10 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100">
            <i className="ri-double-quotes-l text-accent-700 text-xl"></i>
          </div>
          <p className="text-xs font-semibold uppercase tracking-widest text-foreground-500 mb-3">
            Verified Reviews
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            Why Shoppers Trust GTBuy
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.slice(0, 3).map((review, i) => (
            <div key={i} className="p-6 rounded-2xl bg-background-50 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={review.avatarUrl}
                  alt={review.name}
                  className="w-11 h-11 rounded-full object-cover flex-shrink-0"
                />
                <div>
                  <p className="font-semibold text-foreground-900 text-sm">{review.name}</p>
                  <p className="text-xs text-foreground-500">{review.role}</p>
                </div>
              </div>
              <div className="text-accent-500 text-lg mb-3">
                <i className="ri-double-quotes-l"></i>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
          {reviews.slice(3, 5).map((review, i) => (
            <div key={i} className="p-6 rounded-2xl bg-background-50 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={review.avatarUrl}
                  alt={review.name}
                  className="w-11 h-11 rounded-full object-cover flex-shrink-0"
                />
                <div>
                  <p className="font-semibold text-foreground-900 text-sm">{review.name}</p>
                  <p className="text-xs text-foreground-500">{review.role}</p>
                </div>
              </div>
              <div className="text-accent-500 text-lg mb-3">
                <i className="ri-double-quotes-l"></i>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}